import { State } from '../../types/reducer/State';
import { View } from '../../types/view/View';

export function addView(state: State, view: View): State {
  return {
    ...state,
    user: state.user && { ...state.user, views: [...state.user.views, view] },
  };
}
